export const arrayBufferToString = (data: ArrayBuffer) => {
  return String.fromCharCode.apply(null, Array.from(new Uint8Array(data)));
};
